import Validate from '~/ui/Validate'
import Selectbox from '~/ui/Selectbox'

export default class Form {
  constructor () {
    new Validate()
    new Selectbox()
  }
}
